// import { Table } from "nq-component";
import { InputFactory, dialog } from "nq-component";
import BaseListPage from "../../../../../base/BaseListPage";
import Table from "../../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import AdditionalTalbePresenter from "./AdditionalTalbePresenter";
import { DialogConfirmation } from "../../../../../components/common/Converter";

export default class AdditionalInfoTable extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AdditionalTalbePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      initialData: [],
      referenceName: "",
      referenceAddress: "",
      referenceTel: "",
      objectID: "",
      count: 0,
      limit: 10,
      current: 1,
      // email: sessionStorage.getItem("email"),
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const { objectID } = this.state;
    const { object } = this.props;
    const newObject = await findObjectUseCase().execute("reference_table", {
      where: { empID: object.id },
    });

    this.setState({
      initialData: newObject,
      referenceName: objectID.referenceName,
      referenceAddress: objectID.referenceAddress,
      referenceTel: objectID.referenceTel,
    });
  }

  getCurrent() {
    const { object } = this.props;
    return object.id;
  }

  getCollectionName() {
    return "reference_table";
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.objects !== this.state.objects) {
      const initialEmails = new Set(
        this.state.initialData.map((data) => data.referenceName)
      );
      const newObjects = this.state.objects.filter(
        (data) => !initialEmails.has(data.referenceName)
      );
      if (newObjects.length > 0) {
        localStorage.setItem("Reference", JSON.stringify(newObjects));
      }
    }
  }
  // delete function
  async handleDeleteData(data) {
    // const deletedData = await findObjectUseCase().execute("reference_table", {
    //   where: { id: id },
    // });
    // const prevDelete =
    //   JSON.parse(localStorage.getItem("DeleteReference")) || [];
    // const updatedDeleteData = prevDelete.concat(deletedData);
    // localStorage.setItem("DeleteReference", JSON.stringify(updatedDeleteData));
    // // console.warn("IDDDD:", id);
    // await this.presenter.deleteObjectUseCase.execute("reference_table", id);
    // dialog.close();
    // this.refetchData();
    DialogConfirmation(data.id, this.getCollectionName(), () =>
      this.refetchData()
    );
  }

  async handleEditData(data) {
    this.handleAddReference(data);
  }

  onChangeName(referenceName) {
    this.setState({ referenceName });
  }

  onChangeAddress(referenceAddress) {
    this.setState({ referenceAddress });
  }

  onChangeTelNo(referenceTel) {
    this.setState({ referenceTel });
  }

  handleSaveButton() {
    const { object } = this.props;
    if (this.state.objectID.id !== "") {
      const data = {
        email: object.email,
        empID: object.id,
        referenceName: this.state.referenceName,
        referenceAddress: this.state.referenceAddress,
        referenceTel: this.state.referenceTel,
        id: this.state.objectID.id,
      };

      upsertUseCase().execute("reference_table", data);
      this.refetchData();
      this.refetchData();
      dialog.close();
    } else {
      const data = {
        email: object.email,
        empID: object.id,
        referenceName: this.state.referenceName,
        referenceAddress: this.state.referenceAddress,
        referenceTel: this.state.referenceTel,
      };

      upsertUseCase().execute("reference_table", data);
      this.refetchData();
      this.refetchData();
      dialog.close();
    }
    this.setState({
      referenceName: "",
      referenceAddress: "",
      referenceTel: "",
    });
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  handleAddReference(object) {
    this.state.objectID = object;
    dialog.fire({
      html: (
        <div className="p-2">
          <h4>Add Reference</h4>
          <hr />

          <form
            onSubmit={(e) => {
              e.preventDefault();
              this.handleSaveButton();
            }}
          >
            <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
              Name <span style={{ color: "red" }}>*</span>
            </label>
            <InputFactory
              required
              type="String"
              field="referenceName"
              defaultValue={object.referenceName}
              onChange={this.onChangeName.bind(this)}
            />

            <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
              Address <span style={{ color: "red" }}>*</span>
            </label>
            <InputFactory
              required
              type="String"
              defaultValue={object.referenceAddress}
              field="referenceAddress"
              onChange={this.onChangeAddress.bind(this)}
            />

            <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
              Tel No. <span style={{ color: "red" }}>*</span>
            </label>
            <InputFactory
              required
              type="Number"
              field="referenceTel"
              defaultValue={object.referenceTel}
              onChange={this.onChangeTelNo.bind(this)}
            />

            <div className="mt-4 mb-4 d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-light fs-sm me-3"
                onClick={() => dialog.close()}
              >
                Cancel
              </button>
              <button
                // onClick={this.handleSaveButton.bind(this)}
                type="submit"
                className="btn btn-primary fs-sm me-3"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      ),
      footer: false,
    });
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, current, count, limit } = this.state;
    return (
      <>
        <div className="m-4">
          <div className="d-flex justify-content-end">
            <button
              onClick={this.handleAddReference.bind(this)}
              className="btn btn-primary"
            >
              Add Reference
            </button>
          </div>
          <Table
            objectId={(data) => this.handleDeleteData(data)}
            refetch={this.refetchData.bind(this)}
            objectData={this.handleEditData.bind(this)}
            progress={loading}
            fields={schema.fields}
            objects={objects}
            collection={schema}
            count={count}
            limit={limit}
            current={current}
            loadPagination={this.onClickPagination.bind(this)}
            actionsList={[
              {
                label: "Remove",
                actionType: "delete",
              },
              {
                label: "Edit",
                actionType: "object",
              },
            ]}
            excludeFields={Object.keys(schema.fields).reduce(
              (acc, key) => {
                const options = schema.fields[key];
                if (options.read === false) {
                  acc.push(key);
                }
                switch (options._type || options.type) {
                  case "Relation":
                  case "Array":
                  case "Object":
                  case "File":
                    acc.push(key);
                    break;
                  default:
                }
                return acc;
              },
              ["Id", "Created At", "Updated At"]
            )}
            onClickItem={this.onClickItem.bind(this)}
          />
        </div>
      </>
    );
  }
}
